import styled from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { MediaQuery } from '../../../shared/constants/Styles';
import { Typography } from '../../../shared/constants/Typographies';

export const Carousel = styled.div`
  padding-top: 50px;
  background: linear-gradient(${Color.ZIRCON} 65%, transparent 35%);
`;

export const Head = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 115px 45px 100px;
  align-items: center;

  max-width: ${({ isDisplayedAsGallery }) =>
    isDisplayedAsGallery ? '1250px' : 'unset'};
  margin: ${({ isDisplayedAsGallery }) =>
    isDisplayedAsGallery ? 'auto' : 'none'};

  ${MediaQuery.XL_AND_UP} {
    & > * {
      margin: ${({ isDisplayedAsGallery, displayedItems }) =>
        isDisplayedAsGallery && displayedItems > 2 ? '0 15px' : 'none'};
    }
  }

  ${MediaQuery.XL_AND_DOWN} {
    padding: 0 30px 30px 15px;
  }

  ${MediaQuery.L_AND_DOWN} {
    padding: 0 30px 30px 15px;
  }
`;

export const Title = styled.span`
  ${Typography.XXXL_BOLDER};
  color: ${Color.CLOUD_BURST};
  margin: 0;
`;

export const ButtonWrapper = styled.div`
  display: ${({ hasNavigation, displayedItems }) =>
    hasNavigation || displayedItems === 2 ? 'inline-flex' : 'none'};

  ${MediaQuery.L_AND_DOWN} {
    display: inline-flex;
  }

  button {
    margin-left: 10px;
  }
`;

export const ContentContainer = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;

  max-width: ${({ isDisplayedAsGallery }) =>
    isDisplayedAsGallery ? '1250px' : 'unset'};
  margin: ${({ isDisplayedAsGallery }) =>
    isDisplayedAsGallery ? 'auto' : 'none'};
  padding: ${({ isDisplayedAsGallery }) =>
    isDisplayedAsGallery ? '0 85px 50px 85px' : '0 100px 50px 85px'};

  ${MediaQuery.XL_AND_DOWN} {
    padding: 0 15px 50px 0;
  }

  ${MediaQuery.M_AND_DOWN} {
    padding: 0 0 50px 0;
  }
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const ListContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const List = styled.div`
  display: flex;
  transition: all 250ms linear;

  justify-content: ${({ isDisplayedAsGallery }) =>
    isDisplayedAsGallery ? 'space-between' : 'initial'};

  ${MediaQuery.XL_AND_UP}, ${MediaQuery.XL_AND_DOWN} {
    transform: ${({ currentIndex, displayedItems }) =>
      `translateX(-${currentIndex * (100 / displayedItems)}%)`};

    & > * {
      width: ${({ displayedItems, isDisplayedAsGallery }) =>
        isDisplayedAsGallery ? 'unset' : `calc(100% / ${displayedItems})`};
    }
  }

  ${MediaQuery.L_AND_DOWN} {
    & > * {
      width: 50%;
    }
  }

  ${MediaQuery.M_AND_DOWN} {
    transform: ${({ currentIndex }) => `translateX(-${currentIndex * 100}%)`};
    display: -webkit-box;

    & > * {
      width: 100%;
    }
  }
`;

export const Item = styled.div`
  & > * {
    display: flex;
    margin: 5px 15px 0 15px;
    flex: 1 0 auto;

    ${MediaQuery.XL_AND_UP} {
      justify-content: ${({ isDisplayedAsGallery }) =>
        isDisplayedAsGallery ? 'center' : 'iniatial'};
    }
  }
`;

export const ButtonContainer = styled.div`
  text-align: center;

  ${MediaQuery.M_AND_DOWN} {
    margin: 0 15px;
  }
`;
